module.exports = __webpack_public_path__ + "img/banner-01.e45cf747.jpg";